/* eslint-disable */
var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.13.0/dist/search-insights.min.js";

!function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
(e[s].queue=e[s].queue||[]).push(arguments)},e[s].version=(n.match(/@([^\/]+)\/?/)||[])[1],i=a.createElement(t),c=a.getElementsByTagName(t)[0],
i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
}(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");

// Initialize the library with cookie persistence for consistent user tokens (PP-753)
aa('init', {
  appId: window.algoliaConfig.appId,
  apiKey: window.algoliaConfig.apiKey,
  useCookie: true
}); 
/* eslint-enable */ 